/* tslint:disable */
import { injectGlobal } from 'react-emotion';
import theme from './theme';

injectGlobal`
  * {
    box-sizing: border-box;
    font-weight: normal;
  }
  body {
    font-family: ${theme.primaryFont};
    font-size: ${theme.baseFontSize};
    background-color: ${theme.backgroundColor};
    margin: 0;
    letter-spacing: 1px;
    overflow-x: hidden;
  }
  input:focus,
  select:focus,
  textarea:focus,
  button:focus {
      outline: none;
  }
  #root {
    position: relative;
    height: 100vh;
  }
  svg {
    transition: fill 0.25s ease-out;
    transition-delay: 0s;
  }
  body, p, small, label {
    overflow-wrap: break-word;
  }
  a, button {
    transition: all ${theme.transition};
  }
  h1, h2, h3, h4, h5, h6 {
    margin: 0 0 ${theme.spacing.standard}px 0;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1 {
    font-family: 'SangBleu Sunrise Bold';
    font-size: ${theme.fontSizes.x4large};
    line-height: 80px;
  }
  h2 {
    font-family: 'Apercu Pro Bold';
    font-size: ${theme.fontSizes.x4large};
    line-height: 72px;
  }
  h3 {
    font-family: 'SangBleu Sunrise Bold';
    font-size: ${theme.fontSizes.x2large};
    line-height: 56px;
  }
  h4 {
    font-family: 'Apercu Pro Bold';
    font-size: ${theme.fontSizes.xlarge};
    line-height: 40px;
  }
  h5 {
    font-family: 'Apercu Pro Bold';
    font-size: ${theme.fontSizes.large};
    line-height: 32px;
  }
  h6 {
    font-family: 'Apercu Pro Medium';
    font-size: ${theme.fontSizes.medium};
    line-height: 32px;
  }
  p {
    line-height: 1.5em;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  ul {
    margin-top: 0;
    margin-bottom: ${theme.spacing.standard}px;
    padding: 0;
  }
  b {
    font-family: 'Apercu Pro Medium';
  }
  hr {
    border-top: 0.5px solid ${theme.colors.Transparent.Black07};
    border-bottom: 0.5px solid ${theme.colors.Transparent.Black07};
    height: 0;
    margin: 0;
  }
  select {
    font-family: ${theme.primaryFont};
    font-size: ${theme.baseFontSize};
  }
  .no-margin {
    margin: 0;
  }
  .initial-letter:first-letter {
    float: left;
    //font-family: 'SangBleu Kingdom Regular';
    font-size: 3.052em;
    line-height: 0.942;
    padding: 3px 3px 0px 0;
  }
  .fade-in-enter {
    opacity: 0.01;
    transform: scale(1) translateY(20%);
  }
  .fade-in-enter-active {
    opacity: 1;
    transform: scale(1) translateY(0%);
    transition: all ${theme.transition};
  }
  .fade-in-exit {
    opacity: 1;
    transform: scale(1) translateY(0%);
  }
  .fade-in-exit-active {
    opacity: 0.01;
    transform: scale(1) translateY(20%);
    transition: all ${theme.transition};
  }
  #terms h1,
  #terms h2,
  #terms h3 {
    font-weight: bold;
  }
  #terms h1 {
    font-size: ${theme.fontSizes.x2large};
  }
  #terms h2 {
    font-size: ${theme.fontSizes.xlarge};
  }
  #terms h3 {
    font-size: ${theme.fontSizes.large};
  }
  @keyframes animatedPaychecks {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
  }
  @-webkit-keyframes animatedPaychecks {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
  }
  #animated-paychecks {
    -webkit-animation-direction: reverse;
    -webkit-animation-duration: 60s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: animatedPaychecks;
    -webkit-animation-timing-function: linear;
    animation: animatedPaychecks 60s linear reverse infinite; 
    background-position: 0 0;
    background-repeat: repeat-x; 
    height: 200px;
    opacity: 1;
    position: absolute;
    top: 100px;
    width: 6984px;
  }
`;
/* tslint:enable */
